module.exports = __webpack_public_path__ + "img/maps.68432288.png";